import { LegendWeek } from "../../components/legend/legendWeek";
import { Calendar } from "../../components/planning/calendrier";
export function Planning() {

    return (
        <>
            <Calendar />
            <LegendWeek></LegendWeek>
        </>
    );
}

